module.exports = {"pageTitleText":"前台配置","bulletinTitleText":"系统公告 / User Guide 连结","isShowBulletinBoard":"于首页显示","userGuideText":"User Guide URL","sendMailToAdmin":"Email","bulletin":"公告内容"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/frontends.json
// module id = rMrB
// module chunks = 3